import React, { Component, Fragment } from 'react';
import { fonts, colors } from '@peachjar/components';
import TaskBox from './TaskBox';
import SuccessMessage from './SuccessMessage';
import InProgressMessage from './InProgressMessage';
import { css } from 'react-emotion';

// remove default potion after we figure out the export issue
const { jungle } = colors;

const styles = {
  description: css`
     {
      font-size: 0.8rem;
      margin-bottom: 0.2rem;
    }
  `,
  header: css`
     {
      font-weight: 600;
      font-size: ${fonts.pjFontSize06};
    }
  `,
  link: css`
     {
      color: ${jungle} !important;
    }
  `,
  section: css`
     {
      padding-bottom: 1rem;
    }
  `,
};

const TaskSection = ({
  header,
  description,
  title,
  completionTask,
  completionStatus,
  completionText,
  hasLink,
  showLearnMoreModal,
  children,
  assignee,
  isAssigneePresent,
  event,
}) => (
  <div className={styles.section}>
    <h1 className={styles.header}>{header}</h1>
    {(() => {
      if (completionStatus === 'wait-for-check') {
        return (
          <InProgressMessage
            task="Payment"
            status="In Progress"
            assignee={assignee}
            isAssigneePresent={isAssigneePresent}
          />
        );
      } else if (
        completionStatus === 'paid' ||
        completionStatus === 'signed' ||
        event === 'signing_complete'
      ) {
        return (
          <SuccessMessage
            task={completionTask}
            status={completionText}
            isAssigneePresent={isAssigneePresent}
          />
        );
      }

      return (
        <Fragment>
          <div className={styles.description}>
            {description}{' '}
            {hasLink ? (
              <a className={styles.link} onClick={showLearnMoreModal}>
                Learn More
              </a>
            ) : null}
          </div>
          <TaskBox title={title}>
            <TaskBox.Status assignee={assignee} />
            <TaskBox.Action>{children}</TaskBox.Action>
          </TaskBox>
        </Fragment>
      );
    })()}
  </div>
);
export default TaskSection;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/TaskSection.jsx